import {
  CSSProperties,
  LegacyRef,
  ReactElement,
  ReactNode,
  SyntheticEvent,
  useContext
} from 'react';
import cc from 'classcat';
import { RowContext } from '../Row/RowContext';
import './index.less';

type ColProps = {
  span?: number;
  flex?: string;
  offset?: number;
  pull?: number;
  push?: number;
  order?: number;
  style?: CSSProperties;
  children?: ReactNode;
  className?: string;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xxl?: number;
  dir?: string;
  ref?: LegacyRef<HTMLDivElement>;
  id?: string;
  onClick?: (e: SyntheticEvent) => void;
};

const ROW_WIDTH = 100;
const COL_MAX_COUNT = 24;

export const Col = ({
  span,
  flex,
  offset,
  pull,
  push,
  order,
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  style,
  children,
  className,
  dir,
  ref,
  id,
  onClick
}: ColProps): ReactElement => {
  const { gutter } = useContext(RowContext);

  const normalizedGutter = gutter
    ? gutter.every(g => g !== undefined)
      ? gutter
      : null
    : null;

  const colPaddings = normalizedGutter && {
    paddingLeft: normalizedGutter[0] / 2,
    paddingRight: normalizedGutter[0] / 2
  };

  const colStyle = {
    flex: flex ? flex : span && `0 0 ${(span * ROW_WIDTH) / COL_MAX_COUNT}%`,
    maxWidth: span && `${(span * ROW_WIDTH) / COL_MAX_COUNT}%`,
    display: flex,
    ...(gutter ? colPaddings : {}),
    ...style
  } as CSSProperties;

  return (
    <div
      className={cc([
        'custom__col',
        {
          [`col__push--${push}`]: push,
          [`col__pull--${pull}`]: pull,
          [`col__order--${order}`]: order,
          [`col__offset--${offset}`]: offset,
          [`col__xs--${xs}`]: xs,
          [`col__sm--${sm}`]: sm,
          [`col__md--${md}`]: md,
          [`col__lg--${lg}`]: lg,
          [`col__xl--${xl}`]: xl,
          [`col__xxl--${xxl}`]: xxl,
          [`${className}`]: className
        }
      ])}
      onClick={onClick}
      style={colStyle}
      dir={dir}
      ref={ref}
      id={id}
    >
      {children}
    </div>
  );
};
